var _rect, _path, _rect2, _rect3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMWaytoBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 720,
    height: 1207,
    viewBox: "0 0 720 1207",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 720,
    height: 1207,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M327.203 87.92L319.443 116H317.483L309.803 90.72L302.003 116H300.123L292.483 87.92H294.403L301.123 113.48L308.843 87.92H310.843L318.483 113.64L325.243 87.92H327.203ZM329.752 105.12C329.752 102.88 330.192 100.92 331.072 99.24C331.978 97.56 333.218 96.2667 334.792 95.36C336.392 94.4533 338.205 94 340.232 94C342.525 94 344.472 94.56 346.072 95.68C347.672 96.8 348.792 98.2267 349.432 99.96V94.28H351.232V116H349.432V110.28C348.792 112.04 347.658 113.493 346.032 114.64C344.432 115.76 342.498 116.32 340.232 116.32C338.205 116.32 336.392 115.867 334.792 114.96C333.218 114.027 331.978 112.72 331.072 111.04C330.192 109.333 329.752 107.36 329.752 105.12ZM349.432 105.12C349.432 103.227 349.032 101.56 348.232 100.12C347.458 98.6533 346.392 97.5333 345.032 96.76C343.672 95.96 342.152 95.56 340.472 95.56C338.712 95.56 337.165 95.9467 335.832 96.72C334.498 97.4667 333.458 98.56 332.712 100C331.965 101.44 331.592 103.147 331.592 105.12C331.592 107.093 331.965 108.8 332.712 110.24C333.458 111.68 334.498 112.787 335.832 113.56C337.192 114.333 338.738 114.72 340.472 114.72C342.152 114.72 343.672 114.333 345.032 113.56C346.418 112.76 347.498 111.64 348.272 110.2C349.045 108.733 349.432 107.04 349.432 105.12ZM373.946 94.28L361.306 126.2H359.466L363.506 116L354.386 94.28H356.346L364.506 114L372.106 94.28H373.946ZM403.171 87.92V89.44H395.171V116H393.371V89.44H385.371V87.92H403.171ZM416.216 116.32C414.189 116.32 412.363 115.867 410.736 114.96C409.109 114.053 407.829 112.76 406.896 111.08C405.989 109.373 405.536 107.387 405.536 105.12C405.536 102.88 406.003 100.92 406.936 99.24C407.869 97.5333 409.149 96.24 410.776 95.36C412.429 94.4533 414.269 94 416.296 94C418.323 94 420.149 94.4533 421.776 95.36C423.403 96.24 424.669 97.52 425.576 99.2C426.509 100.88 426.976 102.853 426.976 105.12C426.976 107.387 426.509 109.373 425.576 111.08C424.643 112.76 423.349 114.053 421.696 114.96C420.069 115.867 418.243 116.32 416.216 116.32ZM416.216 114.72C417.789 114.72 419.256 114.373 420.616 113.68C422.003 112.96 423.109 111.88 423.936 110.44C424.763 109 425.176 107.227 425.176 105.12C425.176 103.04 424.763 101.28 423.936 99.84C423.109 98.4 422.016 97.3333 420.656 96.64C419.296 95.92 417.829 95.56 416.256 95.56C414.683 95.56 413.216 95.92 411.856 96.64C410.523 97.3333 409.443 98.4 408.616 99.84C407.789 101.28 407.376 103.04 407.376 105.12C407.376 107.227 407.776 109 408.576 110.44C409.403 111.88 410.483 112.96 411.816 113.68C413.176 114.373 414.643 114.72 416.216 114.72Z",
    fill: "#404040"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 160.8,
    width: 480,
    height: 2.4,
    fill: "url(#paint0_linear_686_34)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 160.8,
    width: 480,
    height: 2.4,
    fill: "white",
    fillOpacity: 0.4
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_686_34",
    x1: 120,
    y1: 160.8,
    x2: 600,
    y2: 160.799,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00F3C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#42C8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7737FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMWaytoBackground);
export default __webpack_public_path__ + "static/media/mWaytoBackground.68b24ac84730266b38675062266fa37b.svg";
export { ForwardRef as ReactComponent };